angular.module('tf.directives')

.directive("tfFooter",[function(){
        return {
            restrict: "E",
            replace:true,
            templateUrl: "js/components/footer/footer.html",
            controller : "FooterController"
        };

    }])

.controller("FooterController",['$scope','$state','RenderService',function($scope, $state, RenderService){
        $scope.state = $state.current.name;
        $scope.renderService = RenderService;
    }]);